module.exports = __webpack_public_path__ + "img/directory--icon.6e68895f.svg";